import React from "react";
import Countdown, { zeroPad } from "react-countdown";

const textClasses = "text-white label-1";
const InProgress = () => <span className={textClasses}>In Progress</span>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <InProgress />;
  } else {
    return (
      <span className={textClasses}>
        {days}D {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    );
  }
};

export default function Timer({ startTime}) {
  return <Countdown date={startTime} renderer={renderer} />;
}
